import React from 'react';
import { AppComponent } from 'utils/components';

export default function Dropdown(props: { component: AppComponent }) {
	console.warn('unimplemented', props.component);

	return <div>dropdown</div>;
}
